import { bindCallback, of, concat, from, Subject, merge as mergeN } from 'rxjs'
import React, { Component } from 'react';
import { EditorState } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { defaultMarkdownParser, defaultMarkdownSerializer } from 'prosemirror-markdown';
import { history,undo, redo } from 'prosemirror-history';
import { keymap } from 'prosemirror-keymap';
import { baseKeymap } from 'prosemirror-commands';
import './CanvasMarkdown.css'
// Use the schema from the default markdown parser
const schema = defaultMarkdownParser.schema;

export class CanvasMarkdown extends Component {
  constructor(props) {
    super(props);
    this.editorRef = React.createRef();
    this.view = null;
  }

  componentDidMount() {
    this.initializeEditor();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content && this.view) {
      // Parse the new markdown value and update the editor state
      const doc = defaultMarkdownParser.parse(this.props.content || '');
      const newState = EditorState.create({
        schema,
        doc,
        plugins: this.view.state.plugins, // Preserve plugins
      });
      this.view.updateState(newState);
    }
  }

  componentWillUnmount() {
    if (this.view) {
      this.view.destroy();
    }
  }

  initializeEditor() {
    const { content } = this.props;

    const onChange = change => {
      this.props.editsSubject.next({
        path,
        type: "user-change",
        oldContent: content,
        newContent: change
      })
    }

    // Parse initial markdown to Prosemirror document
    const doc = defaultMarkdownParser.parse(content || '');

    // Create editor state with basic plugins (history, keymaps)
    const state = EditorState.create({
      schema,
      doc,
      plugins: [
        history(),
        keymap(baseKeymap),
        keymap({
          'Mod-z': undo,
          'Mod-y': redo,
        }),
      ],
    });

    // Create the Prosemirror view
    this.view = new EditorView(this.editorRef.current, {
      state,
      dispatchTransaction: (tr) => {
        // Apply transaction
        const newState = this.view.state.apply(tr);
        this.view.updateState(newState);

        // If the document changed, serialize to markdown and call onChange
        if (tr.docChanged && onChange) {
          const markdown = defaultMarkdownSerializer.serialize(newState.doc);
          onChange(markdown);
        }
      },
    });
  }

  render() {
    return <div ref={this.editorRef} />;
  }
}

